import React, { useState } from "react";
import { useNavigate, useSearchParams, Link } from "react-router-dom";
import { useLocale } from "../context/LocaleContext";
import { Loader2 } from "lucide-react";
import { toast } from "sonner";
import { useShop } from "../context/ShopContext";
import { useAuth, authApi, formatApiError } from "../context/AuthContext";
import { PageTitle } from "../components/Shared";
import Seo from "../components/Seo";

const content = {
  it: {
    title: "Imposta la password",
    intro: "Scegli la password per accedere alla tua Area Clienti IdeaMedia.",
    password: "Nuova password (min 6 caratteri)",
    confirm: "Conferma password",
    submit: "Imposta password e accedi",
    mismatch: "Le password non coincidono",
    noToken: "Link non valido: token mancante.",
    requestNew: "Richiedi un nuovo link",
    success: "Password impostata! Benvenuto nella tua area clienti.",
    wait: "Attendere...",
  },
  en: {
    title: "Set your password",
    intro: "Choose the password to access your IdeaMedia Customer Area.",
    password: "New password (min 6 characters)",
    confirm: "Confirm password",
    submit: "Set password and sign in",
    mismatch: "Passwords do not match",
    noToken: "Invalid link: missing token.",
    requestNew: "Request a new link",
    success: "Password set! Welcome to your customer area.",
    wait: "Please wait...",
  },
};

const AccountSetPassword = () => {
  const { lang } = useShop();
  const { lp } = useLocale();
  const { setUser } = useAuth();
  const c = content[lang];
  const navigate = useNavigate();
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    if (password !== confirm) {
      setError(c.mismatch);
      return;
    }
    setBusy(true);
    setError("");
    try {
      const { data } = await authApi.post("/auth/reset-password", { token, password });
      setUser(data);
      toast.success(c.success);
      navigate(lp("/account"));
    } catch (err) {
      setError(formatApiError(err.response?.data?.detail) || err.message);
    } finally {
      setBusy(false);
    }
  };

  return (
    <div data-testid="set-password-page">
      <Seo title={c.title} description={c.intro} />
      <PageTitle title={c.title} />
      <div className="idm-container idm-acct-auth">
        {!token ? (
          <>
            <p className="idm-acct-error">{c.noToken}</p>
            <Link to={lp("/account/login")} className="idm-acct-link">{c.requestNew}</Link>
          </>
        ) : (
          <>
            <p className="idm-text">{c.intro}</p>
            <form onSubmit={submit} noValidate>
              <div className="idm-field">
                <label htmlFor="sp-password">{c.password}</label>
                <input id="sp-password" type="password" value={password} onChange={(e) => { setPassword(e.target.value); setError(""); }} required data-testid="setpw-password" />
              </div>
              <div className="idm-field">
                <label htmlFor="sp-confirm">{c.confirm}</label>
                <input id="sp-confirm" type="password" value={confirm} onChange={(e) => { setConfirm(e.target.value); setError(""); }} required data-testid="setpw-confirm" />
              </div>
              {error && <p className="idm-acct-error" data-testid="setpw-error">{error}</p>}
              <button type="submit" className="idm-btn-yellow" style={{ animation: "none", marginTop: 16 }} disabled={busy || password.length < 6} data-testid="setpw-submit">
                {busy ? <Loader2 size={15} className="idm-spin" /> : null}
                {busy ? c.wait : c.submit}
              </button>
            </form>
          </>
        )}
      </div>
    </div>
  );
};

export default AccountSetPassword;
